import { Button, InlineError, Input, Spinner, Switch } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import UploadImage from 'components/commons/upload-image'
import MultipleSelect from 'components/commons/multiple-select'

export const BestSeller = ({
    bestSellerDetail,
    optionsProduct,
    errorForm,
    onChangeForm,
    onSearchProduct,
    isLoading,
    isUpdating,
    isLoadingUpload,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-6'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center justify-between border border-neutral-20 px-6 py-4 rounded-lg'}>
                        <p className={'font-semibold text-lg text-black-95'}>Best Seller</p>
                        <div className={'flex items-center space-x-6'}>
                            <p className={'font-semibold'}>{!bestSellerDetail?.is_show ? 'Hide' : 'Show'}</p>
                            <Switch name={'is_show'} checked={!!bestSellerDetail?.is_show} onChange={onChangeForm} />
                        </div>
                    </div>
                    <TabToggle
                        className={'!mb-12'}
                        title={'General'}
                        content={
                            <div className={'flex space-x-16'}>
                                <div className={'flex-1 flex-col space-y-5'}>
                                    <div
                                        className={`flex flex-col ${(bestSellerDetail?.best_seller?.desktop_background_url?.base64 || bestSellerDetail?.best_seller?.desktop_background_url) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90 required'}>
                                            Background Desktop (1366px x 631px)
                                        </div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={'desktop-background'}
                                            value={
                                                bestSellerDetail?.best_seller?.desktop_background_url?.base64 ||
                                                bestSellerDetail?.best_seller?.desktop_background_url
                                            }
                                            onChange={(value) =>
                                                onChangeForm({ name: 'desktop_background_url', value })
                                            }
                                        />
                                        <InlineError
                                            className='mt-2'
                                            message={errorForm?.best_seller?.desktop_background_url}
                                        />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Title</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'title'}
                                            placeholder={'Masukkan title'}
                                            value={bestSellerDetail?.best_seller?.title}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className='mt-2' message={errorForm?.best_seller?.title} />
                                    </div>
                                </div>
                                <div className={'flex-1 flex-col space-y-5'}>
                                    <div
                                        className={`flex flex-col ${(bestSellerDetail?.best_seller?.mobile_background_url?.base64 || bestSellerDetail?.best_seller?.mobile_background_url) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90 required'}>
                                            Background Mobile (393px x 486px)
                                        </div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={'mobile-background'}
                                            value={
                                                bestSellerDetail?.best_seller?.mobile_background_url?.base64 ||
                                                bestSellerDetail?.best_seller?.mobile_background_url
                                            }
                                            onChange={(value) => onChangeForm({ name: 'mobile_background_url', value })}
                                        />
                                        <InlineError
                                            className='mt-2'
                                            message={errorForm?.best_seller?.mobile_background_url}
                                        />
                                    </div>
                                    <div className={'flex flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Pilih Product</div>
                                        <MultipleSelect
                                            name={'product_ids'}
                                            placeholder={'Search Product...'}
                                            onSearch={onSearchProduct}
                                            value={bestSellerDetail?.best_seller?.product_ids}
                                            options={optionsProduct}
                                            onChange={onChangeForm}
                                        />
                                        <InlineError className={'mt-2'} message={errorForm?.best_seller?.product_ids} />
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex justify-end w-[calc(100%-544px)] py-3 bg-white fixed bottom-0 right-9 z-20'}>
                        <Button
                            className={'w-[200px] !bg-gradient-to-r !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                            loading={isLoadingUpload || isUpdating}
                            title={'SAVE ALL CHANGES'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
